import { Row, Text } from '@metaicg/sensei-ui';
import { Link } from 'react-router-dom';

export type BreadcrumbsData = {
  label: string;
  to?: string;
}[];

export type BreadcrumbsProps = {
  data: BreadcrumbsData;
  lastHasLink?: boolean;
};

const Breadcrumbs = ({ data, lastHasLink }: BreadcrumbsProps) => (
  <Row>
    {data.map((item, i) => {
      if (i < data?.length - 1 || lastHasLink) {
        return (
          <Link key={item.label} to={item.to || '#'}>
            <Text key={item.label} size="normal" weight={300} color="neutral.palette400">
              {item.label} /{'\u00a0'}
            </Text>
          </Link>
        );
      }

      return (
        <Text key={item.label} size="normal" weight={300} color="neutral.white">
          {item.label}
        </Text>
      );
    })}
  </Row>
);

export default Breadcrumbs;
